import { render, staticRenderFns } from "./GenericNode.vue?vue&type=template&id=a63e4640"
import script from "./GenericNode.vue?vue&type=script&lang=js"
export * from "./GenericNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports